import Vue from 'vue';
import { Tooltip } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.metrodark.css';

Vue.use(Tooltip);

export default Tooltip;
